import { makeid } from 'utils/helpers/makeid';

import type { TFormItem } from '../../types';

/**
 * #1 Reading Status Check.
 * - Recovered reading: pre-select "Already Recovered" (in use-logic). "Still critical /
 *   at-risk" stays enabled; switching to it is an override, so it reveals a mandatory
 *   free-text explanation.
 * - Non-recovered reading: pre-select "Still critical / at-risk". "Already Recovered" is
 *   disabled (the reading never recovered on its own).
 */
export const buildStep1Config = (isRecovered: boolean): TFormItem[] => [
  {
    key: makeid(10),
    name: 'readingStatus',
    type: 'radio',
    title: <p>#1 Reading Status Check</p>,
    description: 'Record the current status of the reading.',
    required: true,
    options: [
      {
        key: makeid(10),
        label: 'Still critical / at-risk',
        value: 'still-critical',
        // Only an override when the reading had recovered — reveal a mandatory reason.
        hideSubitemsIfParentNotSelected: true,
        subItems: isRecovered
          ? [
              {
                key: makeid(10),
                name: 'readingStatusReason',
                type: 'textarea',
                title: (
                  <p>
                    Reason for changing Already Recovered to Still critical /
                    at-risk
                  </p>
                ),
                required: true,
              },
            ]
          : undefined,
      },
      {
        key: makeid(10),
        label: 'Already Recovered',
        value: 'already-recovered',
        disabled: !isRecovered,
      },
    ],
  },
];
